import { robotsNavItems } from "../components/Gamification/constants";

export const navItems = [
  {
    name: "Інформація про застосунок",
    link: "edit",
  },
  {
    name: "Сповіщення застосунку",
    link: "notifications",
  },
  {
    name: "Головні сторінки застосунку",
    link: "pages",
  },
  {
    name: "Версії",
    link: "versions",
  },
  {
    name: "VR версії",
    link: "vr",
  },
  {
    name: "Версії дошок",
    link: "interactive-board",
  },
  {
    name: "Опитування",
    link: "polls",
  },
  {
    name: "Нагороди",
    link: "achievements",
  },
  ...robotsNavItems,
  {
    name: "Маркетингові модалки",
    link: "marketing-modals",
  },
  {
    name: "Тренажери",
    link: "trainers",
  },
];

export const navItemsMobileAppsMainPages = [
  {
    name: "Головна",
    link: "edit",
  },
  {
    name: "Список моделей",
    link: "models",
  },
  {
    name: "Уроки",
    link: "lessons",
  },
];
